<template>
  <div>
    <div class="conter">
        <div class="conter">
	<div class="signboard">
   	<h3>标牌信息</h3>
       <p>产品名称：<span>{{info.name}}</span></p>
       <ul class="clearfix">
       	<li>批次：<span>{{info.  batch}}</span></li>
           <li>时间：<span>{{info.date}}</span></li>
           <li>材质：<span>{{info.brand}}</span></li>
           <li>规格：<span>Φ{{info.specifications}}</span></li>
           
           <li>重量：<span>{{info.weight}}</span></li>
           <li>支数：<span>{{info.count}}</span></li>
           <li>班组：<span>{{info.team}}</span></li>
       </ul>
    </div>
     <div class="physics">
    	<h3>成分信息</h3>
        <div v-html="info.chemistrydesc" class="chemistry-table"></div>
    </div>
    <div class="physics">
    	<h3>物理特性</h3>
        <div v-html="info.physicsdesc" class="chemistry-table"></div>
        
        <img src="https://api.dianzibiaopai.top/public/content/img_1.jpg" alt="图片">
        <img src="https://api.dianzibiaopai.top/public/content/img_2.jpg" alt="图片">
    </div>
	
	 <div class="physics">
		<h3>电子质保书</h3>
		 <table border="0" cellpadding="0" cellspacing="0">
			<tbody><tr>
				<td><a href="https://sales.jggroup.cn/api/quality-page" target="_blank">电子质保书下载</a></td><td>
			</td></tr>
		 </tbody></table><div>
	
		<div class="company">
    	<h3>山西晋城钢铁控股集团有限公司</h3>
        <p>山西晋城钢铁控股集团有限公司（简称晋钢控股集团），是山西省重点钢铁联合企业、省委省政府确立支持实施钢铁上下游整合重组的主体企业和晋城市产业链链主企业。自2002年创立以来，集团现已发展成为集煤、焦、钢、材及余能综合循环利用和高端薄板精深加工于一体的全产业链钢铁联合企业，下辖晋钢智造、顺盛、煜盛、永硕、洛凯威、安晟通、华安焦化和晋鑫新能源8个规上工业企业主体，是中国民营企业500强、中国制造业500强、中国对外贸易500强企业。截至2021年底，集团总占地7平方公里，总资产306亿元，员工10700人。2021年，集团实现销售收入420.62亿元，上缴税金超10亿元。晋钢控股集团贯彻新发展理念，坚持高质量转型发展，加快产业升级步伐，实现制造智能化、产品高端化、绿色低碳化高质量转型，努力打造智能智造、业财一体、两化融合的现代钢铁企业。至“十四五”末，晋钢控股集团将建成千万吨、千亿级全产业链现代钢铁产业集群。</p>
        <ul>
        	<li>地址：山西省晋城市巴公工业园区</li>
        	<li>网址：www.jggroup.cn</li>
        	<li>售后服务部电话：4000078669/ 销售：0356-3878819 销售中心：13620646553/0356-3878833 </li>
        	<li>传真：0356-3929777</li>
        </ul>
        <img src="https://api.dianzibiaopai.top/public/content/img_3.png" alt="二维码">
    </div>
</div></div></div>
    </div>
  </div>
</template>

<script>
export default {
    props:['id','info'],

    data(){
        return{
            info:{}
        }
    },
 
}
</script>

<style scoped>
*{margin:0; padding:0;}
a{text-decoration:none; color:#3b5998;}
a:hover{text-decoration:none; cursor: pointer;}
ul li,ol li{list-style:none;}
img{border:none; width:100%;}
html,body{font-size:0.9rem; font-family:"Arial","Microsoft YaHei"; color:#343434; background:#fff;}
.clearfix:after{content:""; display:block; clear:both; height:0; line-height:0; visibility:hidden;}
.clearfix{zoom:1;}
.fl{float:left;}
.fr{float:right;}



/*标牌信息*/
.signboard{}
.signboard h3,.component h3,.physics h3,.company h3{background:#ebebeb; font-size:16px; padding:10px 0; text-indent:20px; margin-top:20px;}
.signboard p{border-bottom:1px solid #d9d9d9; line-height:40px; padding:0 4%; color:#808080;}
.signboard ul li{float:left; width:42%; border-bottom:1px solid #d9d9d9; line-height:40px; padding:0 4%; color:#808080;}
.signboard ul li span,.signboard p span{color:#343434;}


/*成分信息*/
.component li,.physics li{float:left; width:25.3%; border-bottom:1px solid #d9d9d9; line-height:40px; padding:0 4%; color:#808080;}
.component .component_fr{text-align:right; color:#343434;}
.component .component_center{text-align:center;}

/*物理特性*/
/deep/ .chemistry-table table{width:100% !important; color:#808080 !important;font-size: 0.8rem;}
/deep/ .chemistry-table table td{border-bottom:1px solid #d9d9d9 !important; padding:3% !important;width:30% !important;}
/deep/ .chemistry-table table .physics_center{text-align:center !important;}
/deep/ .chemistry-table table .physics_right{text-align:right !important; color:#343434 !important;}
/deep/ .chemistry-table img{margin-top:10px !important;}


/*晋城福盛钢铁有限公司*/
.company p{border-bottom:1px solid #d9d9d9; text-indent:26px; padding:2% 4%; line-height:24px; font-size:0.9rem;}
.company li{padding:0 4%; line-height:30px;}
.company img{width:50%; padding:4%;}
</style>


// WEBPACK FOOTER //
// src/components/manufacturers6.vue